import React, { Suspense, lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { ContentRoute, LayoutSplashScreen } from "../_layout/layout";

import { DashboardConsorcioCard } from "./pages/gd/dashboardConsorcio/DashboardConsorcioCard";

const GDPage = lazy(() => import("./pages/routerPage"));

export default function BasePage() {
  // useEffect(() => {
  //   console.log('Base page');
  // }, []) // [] - is required if you need only one call
  // https://reactjs.org/docs/hooks-reference.html#useeffect

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from="/" to="/page/dashboard-consorcio" />
        }
        <ContentRoute
          path="/page/dashboard-consorcio"
          component={DashboardConsorcioCard}
        />

        <Route path="/page" component={GDPage} />
        <Redirect to="error" />
      </Switch>
    </Suspense>
  );
}
